import { render, staticRenderFns } from "./EventsAndCardsOverview.vue?vue&type=template&id=36773478&scoped=true&"
import script from "./EventsAndCardsOverview.vue?vue&type=script&lang=js&"
export * from "./EventsAndCardsOverview.vue?vue&type=script&lang=js&"
import style0 from "./EventsAndCardsOverview.vue?vue&type=style&index=0&id=36773478&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36773478",
  null
  
)

export default component.exports